import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import TopBar from '@/components/TopBarMenu.vue';

// import $ from 'jquery'

// let data = $('#app');
// console.log(data);



export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar, { msg: "Welcome" })
  ]))
}
}

})